// extracted by mini-css-extract-plugin
export default {"table":"FeaturesComponents_table__qZubm","imageContainer":"FeaturesComponents_imageContainer__HH92W","light":"FeaturesComponents_light__-XjRQ"};